var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FADB14"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4375 14.6092H21.1758V10.4529C21.1758 9.14113 20.1126 8.07794 18.8008 8.07794H14.1992C12.8874 8.07794 11.8242 9.14113 11.8242 10.4529V14.6092H10.5625C10.2341 14.6092 9.96875 14.8745 9.96875 15.2029V22.3279C9.96875 22.6564 10.2341 22.9217 10.5625 22.9217H22.4375C22.7659 22.9217 23.0312 22.6564 23.0312 22.3279V15.2029C23.0312 14.8745 22.7659 14.6092 22.4375 14.6092ZM17.0195 19.0067V19.9901C17.0195 20.0717 16.9527 20.1385 16.8711 20.1385H16.1289C16.0473 20.1385 15.9805 20.0717 15.9805 19.9901V19.0067C15.8273 18.8967 15.713 18.741 15.654 18.5619C15.5949 18.3828 15.5943 18.1896 15.652 18.0101C15.7098 17.8307 15.823 17.6741 15.9754 17.5631C16.1278 17.452 16.3115 17.3922 16.5 17.3922C16.6885 17.3922 16.8722 17.452 17.0246 17.5631C17.177 17.6741 17.2902 17.8307 17.348 18.0101C17.4057 18.1896 17.4051 18.3828 17.346 18.5619C17.287 18.741 17.1727 18.8967 17.0195 19.0067ZM19.8398 14.6092H13.1602V10.4529C13.1602 9.8796 13.6259 9.41388 14.1992 9.41388H18.8008C19.3741 9.41388 19.8398 9.8796 19.8398 10.4529V14.6092Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon-lock.beffa45c.svg";
export { ForwardRef as ReactComponent };